import React, { useState } from 'react';

import { Grid, Typography, TextField } from '@mui/material';
import { greyOutEmptyTextField } from '../../Helpers/helpers';

const ICLTrippingPower = (props) => {
  const handleChange = props.handleChange;

  const [fanInWater, set_fanInWater] = useState(props.data.fanInWater);
  const [condensorSeized, set_condensorSeized] = useState(
    props.data.condensorSeized
  );
  const [compressorEarth, set_compressorEarth] = useState(
    props.data.compressorEarth
  );
  const [heatersWorking, set_heatersWorking] = useState(
    props.data.heatersWorking
  );
  const [electricalComponents, set_electricalComponents] = useState(
    props.data.electricalComponents
  );

  const handleElementChange = (val, item) => {
    switch (item) {
      case 'fanInWater':
        set_fanInWater(val);
        break;
      case 'condensorSeized':
        set_condensorSeized(val);
        break;
      case 'compressorEarth':
        set_compressorEarth(val);
        break;
      case 'heatersWorking':
        set_heatersWorking(val);
        break;
      case 'electricalComponents':
        set_electricalComponents(val);
        break;

      default:
        break;
    }
    handleChange(val, item);
  };

  return (
    <Grid
      container
      rowSpacing={0}
      margin={0}
      columnSpacing={{ xs: 0 }}
      rowGap={0}
      style={{ marginLeft: 0, marginRight: 0 }}
    >
      <Grid sx={{ border: 'none' }} item xs={12} md={12}>
        <Typography variant='h6' fontWeight='700' fontSize={18}>
          Tripping Power
        </Typography>
      </Grid>
      <Grid
        sx={{ border: 'solid black 1px', borderBottom: 'none' }}
        item
        xs={4}
        md={4}
      >
        <Typography
          fontWeight='300'
          variant='subtitle1'
          paddingLeft={1}
          justifyContent='center'
        >
          Check if drains blocked and fans in water
        </Typography>
      </Grid>
      <Grid
        sx={{
          border: 'solid black 1px',
          borderBottom: 'none',
          borderLeft: 'none',
          background: greyOutEmptyTextField(fanInWater)
        }}
        item
        xs={8}
        md={8}
      >
        <TextField
          id='fanInWater'
          value={fanInWater}
          onChange={(event) =>
            handleElementChange(event.target.value, event.target.id)
          }
          fullWidth
          sx={{ '& fieldset': { border: 'none' } }}
          size='small'
        ></TextField>
      </Grid>
      <Grid
        sx={{ border: 'solid black 1px', borderBottom: 'none' }}
        item
        xs={4}
        md={4}
      >
        <Typography paddingLeft={1}>
          Check if condenser fans have seized{' '}
        </Typography>
      </Grid>
      <Grid
        sx={{
          border: 'solid black 1px',
          borderBottom: 'none',
          borderLeft: 'none',
          background: greyOutEmptyTextField(condensorSeized)
        }}
        item
        xs={8}
        md={8}
      >
        <TextField
          id='condensorSeized'
          value={condensorSeized}
          onChange={(event) =>
            handleElementChange(event.target.value, event.target.id)
          }
          fullWidth
          sx={{ '& fieldset': { border: 'none', borderBottom: 'none' } }}
          size='small'
        ></TextField>
      </Grid>
      <Grid
        sx={{ border: 'solid black 1px', borderBottom: 'none' }}
        item
        xs={4}
        md={4}
      >
        <Typography paddingLeft={1}>
          Check if the compressor is down to earth
        </Typography>
      </Grid>
      <Grid
        sx={{
          border: 'solid black 1px',
          borderLeft: 'none',
          borderBottom: 'none',
          background: greyOutEmptyTextField(compressorEarth)
        }}
        item
        xs={8}
        md={8}
      >
        <TextField
          id='compressorEarth'
          value={compressorEarth}
          onChange={(event) =>
            handleElementChange(event.target.value, event.target.id)
          }
          fullWidth
          size='small'
          sx={{ '& fieldset': { border: 'none' } }}
        ></TextField>
      </Grid>
      <Grid
        sx={{ border: 'solid black 1px', borderBottom: 'none' }}
        item
        xs={4}
        md={4}
      >
        <Typography paddingLeft={1}>
          Check if cabinet has heaters and check they are in working order
        </Typography>
      </Grid>
      <Grid
        sx={{
          border: 'solid black 1px',
          borderLeft: 'none',
          borderBottom: 'none',
          background: greyOutEmptyTextField(heatersWorking)
        }}
        item
        xs={8}
        md={8}
      >
        <TextField
          id='heatersWorking'
          value={heatersWorking}
          onChange={(event) =>
            handleElementChange(event.target.value, event.target.id)
          }
          fullWidth
          size='small'
          sx={{ '& fieldset': { border: 'none' } }}
        ></TextField>
      </Grid>
      <Grid sx={{ border: 'solid black 1px' }} item xs={4} md={4}>
        <Typography paddingLeft={1}>Check all electrical components</Typography>
      </Grid>
      <Grid
        sx={{ border: 'solid black 1px', borderLeft: 'none', background: greyOutEmptyTextField(electricalComponents) }}
        item
        xs={8}
        md={8}
      >
        <TextField
          id='electricalComponents'
          value={electricalComponents}
          onChange={(event) =>
            handleElementChange(event.target.value, event.target.id)
          }
          fullWidth
          size='small'
          sx={{ '& fieldset': { border: 'none' } }}
        ></TextField>
      </Grid>
    </Grid>
  );
};

export default ICLTrippingPower;
